/* luxury-header.js
 * Turns the transparent hero header solid, and opens the mega menu on
 * pointer intent while keeping it operable from the keyboard.
 *
 * The solid switch watches the HERO, not a 1px sentinel at the top of the
 * page. A sentinel at the top stops intersecting after about a pixel of
 * scroll, so the header went solid almost immediately and the transparent
 * state was never really seen. Watching the hero means the header stays
 * transparent for as long as there is media behind it, which is the whole
 * point of the mode.
 *
 * IntersectionObserver rather than a scroll listener, so this costs nothing
 * on the main thread.
 */
(function () {
  'use strict';

  var header = document.querySelector('[data-luxury-header]');
  if (!header) return;

  if (header.classList.contains('luxury-header--transparent')) {
    var main = document.getElementById('MainContent') || document.querySelector('.content-for-layout');
    var target =
      document.querySelector('[data-hero]') ||
      (main && main.firstElementChild) ||
      document.querySelector('[data-header-sentinel]');

    if (target && 'IntersectionObserver' in window) {
      var h = header.getBoundingClientRect().height || 80;

      new IntersectionObserver(
        function (entries) {
          // Solid as soon as the media behind the header has scrolled past it.
          header.classList.toggle('is-solid', !entries[0].isIntersecting);
        },
        { rootMargin: '-' + Math.round(h) + 'px 0px 0px 0px', threshold: 0 }
      ).observe(target);
    } else {
      // No observer: solid is the safe state, since transparent over an
      // unknown background can be unreadable.
      header.classList.add('is-solid');
    }
  }

  /* Mega menu. Opening needs a short intent delay so crossing one trigger on
     the way to another does not flash a panel. Closing needs one too, so a
     diagonal path from trigger into panel is forgiving. */
  var OPEN_DELAY = 90;
  var CLOSE_DELAY = 180;
  var openTimer = null;
  var closeTimer = null;
  var current = null;

  var triggers = header.querySelectorAll('[data-mega-trigger]');
  if (!triggers.length) return;

  function panelFor(trigger) { return document.getElementById(trigger.getAttribute('aria-controls')); }

  function show(trigger) {
    var panel = panelFor(trigger);
    if (!panel || current === panel) return;
    hide();
    panel.setAttribute('data-open', 'true');
    trigger.setAttribute('aria-expanded', 'true');
    header.classList.add('is-open');
    current = panel;
  }

  function hide() {
    if (!current) return;
    current.setAttribute('data-open', 'false');
    header.classList.remove('is-open');
    var open = header.querySelectorAll('[data-mega-trigger][aria-expanded="true"]');
    Array.prototype.forEach.call(open, function (t) { t.setAttribute('aria-expanded', 'false'); });
    current = null;
  }

  function clearTimers() { window.clearTimeout(openTimer); window.clearTimeout(closeTimer); }

  Array.prototype.forEach.call(triggers, function (trigger) {
    var panel = panelFor(trigger);
    if (!panel) return;

    [trigger.closest('.luxury-nav__item'), panel].forEach(function (el) {
      if (!el) return;
      el.addEventListener('mouseenter', function () {
        clearTimers();
        openTimer = window.setTimeout(function () { show(trigger); }, OPEN_DELAY);
      });
      el.addEventListener('mouseleave', function () {
        clearTimers();
        closeTimer = window.setTimeout(hide, CLOSE_DELAY);
      });
    });

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      clearTimers();
      if (current === panel) hide();
      else show(trigger);
    });

    trigger.addEventListener('focus', function () { clearTimers(); show(trigger); });
  });

  header.addEventListener('focusout', function (event) {
    if (!header.contains(event.relatedTarget)) hide();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && current) {
      var trigger = header.querySelector('[data-mega-trigger][aria-expanded="true"]');
      hide();
      if (trigger) trigger.focus();
    }
  });
})();
